import { Controller } from "@hotwired/stimulus"

// Shows only the fields relevant to the selected merchant key source:
//   none → nothing extra   pem → the PEM field   jwks → the JWKS URL field
// The shared claim/audience/issuer/expiry fields ("custom") show for pem OR jwks.
// Degrades gracefully: without JS every group stays visible.
export default class extends Controller {
  static targets = ["select", "pem", "jwks", "custom"]

  connect() {
    this.toggle()
  }

  toggle() {
    if (!this.hasSelectTarget) return

    const source = this.selectTarget.value
    this.pemTargets.forEach((el) => (el.hidden = source !== "pem"))
    this.jwksTargets.forEach((el) => (el.hidden = source !== "jwks"))
    this.customTargets.forEach((el) => (el.hidden = source === "none"))
  }
}
